import { OutlinedInput } from '@mui/material';
import React from 'react';

interface Props {
  readonly value: string;
  readonly id: string;
  readonly disabled?: boolean;
  readonly multiline?: boolean;
  readonly rows?: number;
  readonly fullWidth?: boolean;
  readonly name?: string;
  readonly error?: boolean;
  readonly helperText?: string;

  onChange(value: string): void;
}

export const TextField: React.FC<Props> = (props: Props): React.ReactElement => {
  const {
    id,
    value,
    name,
    disabled = false,
    multiline = false,
    fullWidth = false,
    rows,
    error = false,
    helperText,
  } = props;
  const { onChange } = props;
  const [internalValue, setInternalValue] = React.useState<string>(value);

  const handleChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    setInternalValue(value);
  }, []);

  React.useEffect((): void => {
    setInternalValue(value);
  }, [value]);

  React.useEffect((): VoidFunction => {
    const timeout = setTimeout((): void => {
      onChange(internalValue);
    }, 300);

    return (): void => {
      clearTimeout(timeout);
    };
  }, [internalValue, onChange]);

  return (
    <div>
      <OutlinedInput
        id={id}
        value={internalValue}
        fullWidth={fullWidth}
        name={name}
        rows={rows}
        multiline={multiline}
        disabled={disabled}
        error={error}
        onChange={handleChange}
      />
      {helperText && (
        <div style={{ color: error ? '#d32f2f' : '#666', fontSize: '0.75rem', marginTop: '3px' }}>
          {helperText}
        </div>
      )}
    </div>
  );
};
